import script from "./VerifyAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyAccount.vue?vue&type=script&setup=true&lang=js"

import "./VerifyAccount.vue?vue&type=style&index=0&id=231a6c19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-231a6c19"]])

export default __exports__